import React from 'react';
import { useLanguage, t } from '../utils/i18n';

const ContactForm = () => {
  const { language } = useLanguage();

  return (
    <div className="bg-white/10 backdrop-blur-md border border-white/20 shadow-lg rounded-[2rem] p-6 md:p-8">
      <form>
        <div className="mb-4">
          <label htmlFor="name" className="block text-akasha-black mb-2">{t('contact.form.name', language.code)}</label>
          <input
            type="text"
            id="name"
            className="w-full px-4 py-2 border border-neutral-400 rounded bg-neutral-200/70 text-akasha-black focus:outline-none focus:ring-2 focus:ring-akasha-brown focus:border-akasha-brown placeholder:text-neutral-500"
            placeholder={t('contact.form.namePlaceholder', language.code)}
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-akasha-black mb-2">{t('contact.form.email', language.code)}</label>
          <input
            type="email"
            id="email"
            className="w-full px-4 py-2 border border-neutral-400 rounded bg-neutral-200/70 text-akasha-black focus:outline-none focus:ring-2 focus:ring-akasha-brown focus:border-akasha-brown placeholder:text-neutral-500"
            placeholder={t('contact.form.emailPlaceholder', language.code)}
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="phone" className="block text-akasha-black mb-2">{t('contact.form.phoneLabel', language.code)}</label>
          <input
            type="tel"
            id="phone"
            className="w-full px-4 py-2 border border-neutral-400 rounded bg-neutral-200/70 text-akasha-black focus:outline-none focus:ring-2 focus:ring-akasha-brown focus:border-akasha-brown placeholder:text-neutral-500"
            placeholder={t('contact.form.phonePlaceholder', language.code)}
          />
        </div>
        <div className="mb-6">
          <label htmlFor="message" className="block text-akasha-black mb-2">{t('contact.form.message', language.code)}</label>
          <textarea
            id="message"
            rows="4"
            className="w-full px-4 py-2 border border-neutral-400 rounded bg-neutral-200/70 text-akasha-black focus:outline-none focus:ring-2 focus:ring-akasha-brown focus:border-akasha-brown placeholder:text-neutral-500"
            placeholder={t('contact.form.messagePlaceholder', language.code)}
            required
          ></textarea>
        </div>
        <button
          type="submit"
          className="w-full py-3 px-6 rounded-full bg-akasha-brown text-white hover:bg-akasha-brown/90 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-akasha-brown focus:ring-offset-2 focus:ring-offset-transparent"
        >
          {t('contact.form.submit', language.code)}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
